import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtAt } from "@/lib/services";

const STEP = { paid: "marcou Pagamento Efetuado", confirmed: "confirmou o pagamento", undone: "marcou como NÃO pago", late_paid: "registrou pagamento atrasado" };

export const PayHistory = ({ stamp }) => {
  const [d, setD] = useState({ items: [] });
  const [month, setMonth] = useState(new Date().toLocaleDateString("sv-SE", { timeZone: "America/Sao_Paulo" }).slice(0, 7));
  useEffect(() => { api.get("/services/history", { params: { month } }).then((r) => setD(r.data)).catch(() => {}); }, [month, stamp]);
  return (
    <div data-testid="service-history" className="rounded-2xl border border-[#1F293D] bg-[#0F141F] p-5">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-200">Histórico de pagamentos</h3>
        <input data-testid="service-history-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)}
          className="rounded-lg border border-[#202D45] bg-[#0B0F17] px-2 py-1 text-xs text-slate-200" />
      </div>
      {!d.items.length && <div className="py-4 text-center text-xs text-slate-500">Nenhum registro neste mês.</div>}
      <div className="space-y-1.5">
        {d.items.map((p) => (
          <div key={p.id} data-testid={`service-history-${p.id}`} className="flex flex-wrap items-center gap-x-2 text-xs text-slate-300">
            <span className="font-mono text-slate-500">{fmtAt(p.at)}</span>
            <b className="text-white">{p.by}</b> {STEP[p.step] || p.step} · {p.label}{p.name ? ` (${p.name})` : ""}
            <span className="text-slate-500">· vencimento {(p.cycle_due || p.cycle).split("-").reverse().join("/")}</span>
            {p.voided && p.step === "paid" && <span className="text-red-400/80">(desfeito)</span>}
          </div>
        ))}
      </div>
    </div>
  );
};
